<template>
	<a
		class="pet-index-top gtm-link_click_count01"
		data-gtm-event-cat-label="ペット天気予報バナークリック"
		data-gtm-event-act-label="trackingPetWeatherBanner"
		href="native://openPetWeather"
	>
		<!-- ローディング -->
		<transition name="fade">
			<div v-if="isLoading" class="pet-index-top__loading">
				<webview-redraw-progress />
			</div>
		</transition>
		<!-- /ローディング -->

		<!-- おさんぽ指数 -->
		<section class="pet-index-top__inner">
			<h2 class="pet-index-top__title">現在のおさんぽ注意指数</h2>
			<div v-if="petIndex.level > 0 && !isError" class="pet-index-top__index">
				<p class="pet-index-top__index--icon"><img :src="require(`@/assets/img/pet/level_${petIndex.level}.png`)" :alt="petIndex.comment"></p>
				<p class="pet-index-top__index--value">
					<span>{{ petIndex.date }}</span>
					<em :class="`is-level-${petIndex.level}`">{{ petIndex.comment }}</em>
				</p>
			</div>
			<p v-else class="pet-index-top__error">データが取得できません</p>
		</section>
	</a>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PET_WEATHER_DATA } from '@/store/modules/pet/mutation-types'

// Compornents
import WebviewRedrawProgress from '@/components/Molecules/WebviewRedrawProgress'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'PetIndexTop',
	components: {
		WebviewRedrawProgress
	},
	data () {
		return {
			isLoading: false,
			isError: false,
			petIndex: {
				level: 0,
				date: '',
				comment: ''
			}
		}
	},
	props: {
	},
	created () {
	},
	mounted () {
		// データの取得
		this.getWeatherData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('pet', ['petWeatherData'])
	},
	methods: {
		// map Vuex actions
		...mapActions('pet', [SET_PET_WEATHER_DATA]),

		// 必要なデータをAPIリクエストする処理
		getWeatherData () {
			this.isLoading = true

			// ペット指数取得API
			this.SET_PET_WEATHER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			}).then(res => {
				const todayIndex = this.petWeatherData.records[0]
				const level = todayIndex.walking_index ? todayIndex.walking_index : 0
				this.petIndex.level = level
				this.petIndex.date = moment.unix(todayIndex.date).format('M/D(ddd)H時')

				switch (level) {
					case 1:
						this.petIndex.comment = '中止'
						break
					case 2:
						this.petIndex.comment = '危険'
						break
					case 3:
						this.petIndex.comment = '警戒'
						break
					case 4:
						this.petIndex.comment = '注意'
						break
					case 5:
						this.petIndex.comment = '快適'
						break
				}
			}).catch(error => {
				// NOTE: エラー処理
				console.log('Error: ', error)
				this.isError = true
			}).finally(() => {
				this.isLoading = false
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

$color-level-1: #F95959;
$color-level-2: #F38089;
$color-level-3: #FFB020;
$color-level-4: #7ECC5A;
$color-level-5: #53C3E5;

$spacing-22: 1.375rem;

.pet-index-top {
	display: block;
	position: relative;
	padding: $spacing-6;
	background-color: $background-primary;
	font-family: $lp-family-primary;
	text-decoration: none;

	// mplusのジャギー対策
	p, span, em, a, h2 { transform: rotate(0.05deg); }

	&__inner {
		position: relative;
		padding-top: 44.2917%;
		background: url('~@/assets/img/pet/pet_index_top.png') no-repeat 0 0;
		background-size: 100% auto;
		box-sizing: border-box;
	}

	&__title {
		position: absolute;
		left: 11.5703%;
		top: 36.0249%;
		margin: 0;
		font-family: $family-primary;
		font-size: $font-size-18;
		color: $text-primary;
		letter-spacing: -.5px;

		@media (max-width: (360px)) {
			font-size: $font-size-14;
		}
	}

	&__index {
		position: absolute;
		display: flex;
		left: 11.5703%;
		top: 54.0373%;
		width: 76.0331%;

		&--icon {
			width: 18.8406%;
			margin: 0;

			img {
				display: block;
				width: 100%;
			}
		}

		&--value {
			display: flex;
			flex-direction: column;
			margin: 0 0 0 $spacing-16;
			font-size: $font-size-18;

			& > span {
				color: $text-primary;
				font-size: $font-size-12;

				@media (max-width: (360px)) {
					font-size: $font-size-10;
				}
			}

			& > em {
				margin-top: $spacing-2;
				font-family: $family-primary;
				font-size: $spacing-22;
				font-style: normal;

				&.is-level-1 { color: $color-level-1; }
				&.is-level-2 { color: $color-level-2; }
				&.is-level-3 { color: $color-level-3; }
				&.is-level-4 { color: $color-level-4; }
				&.is-level-5 { color: $color-level-5; }

				@media (max-width: (360px)) {
					font-size: $font-size-20;
				}
			}
		}
	}

	&__error {
		position: absolute;
		left: 11.5703%;
		top: 54.0373%;
		margin: 0;
		font-size: $font-size-14;
		color: $text-primary;

		@media (max-width: (360px)) {
			font-size: $font-size-12;
		}
	}
}

</style>
